export enum DeliveryTypeEnum {
	D2D = 'D2D',
	D2P = 'D2P',
	P2D = 'P2D',
	P2P = 'P2P',
}
